import { connect } from "react-redux";

import Redirecting from "./Redirecting";

const mapStateToProps = (state, ownProps) => {
  const { title } = ownProps;

  if (title === "Server unreachable") {
    return { title };
  }
  const { config } = state.prerequisites;
  return {
    title,
    versionInfo: `Superuser console - Build: ${
      config["CI_BUILD_ID"] || "unknown"
    } - Date: ${config["CI_STRING_TIME"] || "unknown"}`,
    url: config.ONBOARDING
  };
};

const RedirectingContainer = connect(mapStateToProps)(Redirecting);

export default RedirectingContainer;



// WEBPACK FOOTER //
// ./src/RedirectingContainer.js